import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import HomePage from "./pages/HomePage";
import FeaturesPage from "./pages/FeaturesPage";
import PricingPage from "./pages/PricingPage";
import HowItWorksPage from "./pages/HowItWorksPage";
import AboutPage from "./pages/AboutPage";
import FAQPage from "./pages/FAQPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import TermsOfServicePage from "./pages/TermsOfServicePage";
import SMSProgramPage from "./pages/SMSProgramPage";
import ForCleaningPage from "./pages/ForCleaningPage";
import ForLawnCarePage from "./pages/ForLawnCarePage";
import ForPestControlPage from "./pages/ForPestControlPage";
// LAUNCH HIDDEN: Comparison pages — uncomment to re-enable when SEO/content strategy is ready
// import VsJobberPage from "./pages/VsJobberPage";
// import VsHousecallProPage from "./pages/VsHousecallProPage";
import CustomersPage from "./pages/CustomersPage";
import ComingSoonPage from "./pages/ComingSoonPage";
import ROICalculatorPage from "./pages/ROICalculatorPage";
import ContactPage from "./pages/ContactPage";
import NotFoundPage from "./pages/NotFoundPage";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
};

const Layout = ({ children }) => (
  <div className="min-h-screen bg-[#0A0A0F]">
    <Navbar />
    <main>{children}</main>
    <Footer />
  </div>
);

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Layout><HomePage /></Layout>} />
        <Route path="/features" element={<Layout><FeaturesPage /></Layout>} />
        <Route path="/pricing" element={<Layout><PricingPage /></Layout>} />
        <Route path="/how-it-works" element={<Layout><HowItWorksPage /></Layout>} />
        <Route path="/about" element={<Layout><AboutPage /></Layout>} />
        <Route path="/faq" element={<Layout><FAQPage /></Layout>} />
        <Route path="/privacy-policy" element={<Layout><PrivacyPolicyPage /></Layout>} />
        <Route path="/terms-of-service" element={<Layout><TermsOfServicePage /></Layout>} />
        <Route path="/sms-program" element={<Layout><SMSProgramPage /></Layout>} />
        <Route path="/for-cleaning" element={<Layout><ForCleaningPage /></Layout>} />
        <Route path="/for-lawn-care" element={<Layout><ForLawnCarePage /></Layout>} />
        <Route path="/for-pest-control" element={<Layout><ForPestControlPage /></Layout>} />
        {/* LAUNCH HIDDEN: Comparison pages — uncomment to re-enable */}
        {/* <Route path="/vs-jobber" element={<Layout><VsJobberPage /></Layout>} /> */}
        {/* <Route path="/vs-housecall-pro" element={<Layout><VsHousecallProPage /></Layout>} /> */}
        <Route path="/customers" element={<Layout><CustomersPage /></Layout>} />
        <Route path="/blog" element={<Layout><ComingSoonPage pageName="Blog" /></Layout>} />
        <Route path="/contact" element={<Layout><ContactPage /></Layout>} />
        <Route path="/roi-calculator" element={<Layout><ROICalculatorPage /></Layout>} />
        <Route path="*" element={<Layout><NotFoundPage /></Layout>} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
